{
    "ShowHeaderRowLabel": "Mostrar linha de cabeçalho:",
    "ShowFooterRowLabel": "Mostrar linha de rodapé:",
    "ShowContentRowsLabel": "Mostrar linhas de conteúdo:",
    "ShowSpacerRowsLabel": "Mostrar linha(s) espaçadora(s):",
    "NAME": "ReportContentRowsSettingsLanguage"
}